import { axiosInstance } from '@configs/axios/axiosInstance';

import { Permission } from './fetchPermissions.types';

/**
 * Fetch permissions for current user
 *
 * Endpoint: GET /permissions
 * Request headers:
 * - X-Organization-Id: Organization ID (only for Manage module)
 *
 * Backend filters permissions by:
 * - Manage module: Uses X-Organization-Id header to filter by org
 * - Train/Instruct/Visitor: Returns all permissions for user (no header)
 *
 * Scenarios:
 * - Train/Instruct: No header → backend returns all user permissions
 * - Manage: X-Organization-Id: {id} → backend filters by org
 * - Visitor (no modules): No header → backend returns visitor permissions
 *
 * @param organizationId - Organization ID (only for Manage module)
 * @returns Promise<Permission[]> - Array of permissions
 *
 * @example
 * // Train/Instruct/Visitor modules
 * const permissions = await fetchPermissions();
 *
 * @example
 * // Manage module with organization
 * const permissions = await fetchPermissions('org-123');
 */
export async function fetchPermissions(
  organizationId?: string
): Promise<Permission[]> {
  const { data } = await axiosInstance.get<Permission[]>('/permissions', {
    headers: organizationId ? { 'X-Organization-Id': organizationId } : {},
  });

  return data;
}
